import Logo from "./shared/images/Logo.svg";
import "./app.css";

import ReactGA from "react-ga";
ReactGA.initialize("UA-204051313-1");
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return (
    <div className="App">
      <img src={Logo} className="Logo" alt="Logo" />
      <h1>The complete software solution</h1>
      <h3>Coming Soon...</h3>
    </div>
  );
}

export default App;
